module.exports = __webpack_public_path__ + "img/2720aac.jpg";